/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Close_ButtonInputs */

const en_ocr_close_button = /** @type {(inputs: Ocr_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const fr_ocr_close_button = /** @type {(inputs: Ocr_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_ocr_close_button = /** @type {(inputs: Ocr_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const it_ocr_close_button = /** @type {(inputs: Ocr_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vicino`)
};

const ru_ocr_close_button = /** @type {(inputs: Ocr_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрывать`)
};

const es_ocr_close_button = /** @type {(inputs: Ocr_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const zh_cn2_ocr_close_button = /** @type {(inputs: Ocr_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const ja_ocr_close_button = /** @type {(inputs: Ocr_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近い`)
};

const hi_ocr_close_button = /** @type {(inputs: Ocr_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद करना`)
};

const pt_pt2_ocr_close_button = /** @type {(inputs: Ocr_Close_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Ocr_Close_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_close_button = /** @type {((inputs?: Ocr_Close_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Close_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_close_button(inputs)
	if (locale === "de") return de_ocr_close_button(inputs)
	if (locale === "it") return it_ocr_close_button(inputs)
	if (locale === "ru") return ru_ocr_close_button(inputs)
	if (locale === "es") return es_ocr_close_button(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_close_button(inputs)
	if (locale === "ja") return ja_ocr_close_button(inputs)
	if (locale === "hi") return hi_ocr_close_button(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_close_button(inputs)
	return en_ocr_close_button(inputs)
});